<p-floatlabel class="w-full md:min-w-36" variant="on">
  <p-select
    styleClass="w-full"
    inputId="output_language"
    optionLabel="name"
    optionValue="value"
    [options]="options"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)" />
  <label for="output_language">Output language</label>
</p-floatlabel>
